import { Component, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { Wrapper } from 'src/app/components/wrapper.component';
import { TableColumn, TableMenuItem } from '../../helpers/table.data';
import { allDefaultAssetClipboardColumns, allDefaultAttendeesClipboardColumns, allDefaultExhibitorClipboardColumns, allDefaultPerformerClipboardColumns, allDefaultSponsorClipboardColumns, assetTemplateColumnsById, attendeeTemplateTableColumnsById, exhibitorTemplateColumnsById, performerTemplateTableColumnsById, resourceTemplateColumnsById, sponsorTemplateColumnsById } from '../../helpers/table-helpers';
import { ClipboardTableData, templateTableReselector } from '../../store/reselectors/entity.reselector';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import { ClipboardTab } from 'globals/store/entity.data';
import { ManageTemplatePerformer } from './manage-template-performer';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { ManageTemplateData } from './manage-template-wrapper';
import { ManageTemplateSponsor } from './manage-template-sponsor';
import { ManageTemplateExhibitor } from './manage-template-exhibitor';
import { AccountClipboardPage, EntityClipboard, JoiAccount } from 'globals/store/accounts.data';
import { ManageTemplateAsset } from './manage-template-asset';
import { allDefaultResourceClipboardColumns } from './../../helpers/table-helpers';
import { ManageTemplateResource } from './manage-template-resource';
import { Dictionary } from '@ngrx/entity';
import { ManageTemplateAttendee } from './manage-template-attendee.component';
import { ImageType } from 'globals/store/files.model';
import { filterActions } from 'src/app/store/filters.era';
import { EntitiesService } from 'src/app/services/entities.service';
import { HomeWrapperComponent } from '../nav-bar/home-wrapper.component';
import { LoaderPaneFragmentComponent } from '../loader/loader-pane-fragment.component';
import { AccountMenuComponent } from './account-menu.component';
import { JoiNavWrapper } from '../wrappers/joi-nav-wrapper.component';
import { CommonModule, DatePipe } from '@angular/common';
import { BlackBarWrapperComponent } from '../wrappers/black-bar-wrapper.component';
import { SearchBarComponent } from '../search-bar';
import { NestedTableComponent } from '../nested-table/nested-table.component';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'clipboard',
    templateUrl: './clipboard.html',
    styleUrls: ['../nested-table/nested-table.scss', '../../page.scss', './clipboard.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [HomeWrapperComponent, LoaderPaneFragmentComponent, AccountMenuComponent, JoiNavWrapper, CommonModule, BlackBarWrapperComponent, SearchBarComponent, NestedTableComponent],
})
export class ClipboardComponent extends Wrapper<ClipboardComponent> {
  selectedAccount: JoiAccount
  selectedTab: ClipboardTab = 'PERFORMERS'
  tabs: ClipboardTab[] = ['PERFORMERS', 'EXHIBITORS', 'SPONSORS', 'ASSETS', 'RESOURCES', 'ATTENDEES']
  $killTable: Subject<boolean> = new Subject()
  traceNames = traceNames;
  tableLoading = true
  tableUpdating = false
  tableData: ClipboardTableData[] = []
  tableRowsById: { [id:string]: ClipboardTableData } = {}
  columnData: TableColumn[]
  columnsById: { [id: string]: TableColumn }
  clipboardPagesByAccount: Dictionary<Dictionary<AccountClipboardPage>>
  menuItems: TableMenuItem[] = [
  //  { title: 'Duplicate', method: this.duplicateTemplates.bind(this) },
    { title: 'Delete', method: this.deleteTemplates.bind(this) }
  ]

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private entitiesService: EntitiesService,
  ) {
    super()
    this.subProp(this.store.select('accounts', 'clipboardPagesByAccount'), 'clipboardPagesByAccount')
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.$killTable.next(true)
  }

  openTable() {
    this.$killTable.next(true)
    this.updateSearch('')
    this.tableLoading = true
    switch(this.selectedTab) {
      case 'ATTENDEES':
        this.columnData = allDefaultAttendeesClipboardColumns
        this.columnsById = attendeeTemplateTableColumnsById
        break
      case 'PERFORMERS':
        this.columnData = allDefaultPerformerClipboardColumns
        this.columnsById = performerTemplateTableColumnsById
        break
      case 'SPONSORS':
        this.columnData = allDefaultSponsorClipboardColumns
        this.columnsById = sponsorTemplateColumnsById
        break
      case 'EXHIBITORS':
        this.columnData = allDefaultExhibitorClipboardColumns
        this.columnsById = exhibitorTemplateColumnsById
        break
      case 'ASSETS':
        this.columnData = allDefaultAssetClipboardColumns
        this.columnsById = assetTemplateColumnsById
        break
      case 'RESOURCES':
        this.columnData = allDefaultResourceClipboardColumns
        this.columnsById = resourceTemplateColumnsById
        break
      default:
        console.log("MISSING TYPE!")
        break
    }
    this.selectCallback<{
    tableData: ClipboardTableData[];
    tableRowsById: { [key: string]: ClipboardTableData }}, any>(templateTableReselector, { accountId: this.selectedAccount.id, type: this.selectedTab }, data => {
      if (!data) return
      const { tableData, tableRowsById } = data
      this.tableData = tableData
      this.tableRowsById = tableRowsById
      this.tableLoading = false
    }, this.$killTable)
  }


  async deleteTemplates(toDelete: ClipboardTableData[], event) {
    const entityName = (toDelete.length > 1 ? this.selectedTab : this.selectedTab.slice(0, this.selectedTab.length-1)).toLowerCase()
    const data: ConfirmDeleteData = {
      title: `Delete ${toDelete.length} ${entityName} template${toDelete.length > 1 ? 's' : ''}`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to delete ${toDelete.length > 1 ? `all ${toDelete.length} selected ${entityName}` : `the selected ${entityName}`} from the clipboard?`,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    const key: keyof EntityClipboard = this.selectedTab === 'PERFORMERS' ? 'performers' : this.selectedTab === 'EXHIBITORS' ? 'exhibitors' : this.selectedTab === 'SPONSORS' ? 'sponsors' : this.selectedTab === 'RESOURCES' ? 'resources' : this.selectedTab === 'ASSETS' ? 'assets' : this.selectedTab === 'ATTENDEES' ? 'attendees' : null
    if (!key) throw new Error("MISSING KEY FOR ENTITY!")

    this.tableUpdating = true
    console.log("Should be deleting...", toDelete)
    await this.entitiesService.deleteTemplates(key, toDelete.map(e => e.id), Object.values(this.clipboardPagesByAccount[this.selectedAccount.id] || {}))
    this.tableUpdating = false
  }

  async duplicateTemplates(toDuplicate: ClipboardTableData[]) {
    let type: ImageType
    switch (this.selectedTab) {
      case 'PERFORMERS':
        type = 'performer'
        break
      case 'SPONSORS':
        type = 'sponsor'
        break
      case 'EXHIBITORS':
        type = 'exhibitor'
        break
      case 'ASSETS':
        type = 'asset'
        break
      case 'RESOURCES':
        type = 'resource'
        break
      case 'ATTENDEES':
        type = 'attendee'
        break
    }
    this.tableUpdating = true
    await this.entitiesService.duplicateTemplates(type, toDuplicate.map(r => r.entity), this.selectedAccount.id)
    this.tableUpdating = false
  }

  async openTemplate(row: any) {
    this.changeDetectorRef.detach()
    const data: ManageTemplateData = { entityId: row.id, accountId: this.selectedAccount.id }
    let dialogComponent
    switch (this.selectedTab) {
      case 'PERFORMERS':
        dialogComponent = ManageTemplatePerformer
        break
      case 'SPONSORS':
        dialogComponent = ManageTemplateSponsor
        break
      case 'EXHIBITORS':
        dialogComponent = ManageTemplateExhibitor
        break
      case 'ASSETS':
        dialogComponent = ManageTemplateAsset
        break
      case 'RESOURCES':
        dialogComponent = ManageTemplateResource
        break
      case 'ATTENDEES':
        dialogComponent = ManageTemplateAttendee
        break
    }

    if (dialogComponent) await openDialogGetResult(this.dialog, dialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
    // PerformerBaseTableData| ExhibitorsBaseTableData| SponsorsBaseTableData
  }

  async changeTab(tab: ClipboardTab) {
    this.selectedTab = tab;
    this.openTable()
  }

  updateSearch(keyword: string) {
    this.store.dispatch(filterActions.updateFilter({ filterPageType: 'allTemplatesTable', filterType: 'search', value: keyword }))
  }

  openAccount(account: JoiAccount) {
    console.log({ account })
    this.selectedAccount = account
    this.changeDetectorRef.detectChanges()
    if (account) this.openTable()
  }

  closeTable() {
    this.selectedAccount = null
  }

}
